import { toast } from 'react-toastify'
import useSWR, { SWRConfiguration } from 'swr'
import { learningApi } from '../../../services/api'
import { IThemesAndTopics } from '../components/SearchQuestionsContent/types'
import { IOption } from '../../../components/SearchMultiselect'
import { useDebounce } from 'react-use'
import { useState } from 'react'

export function useGetThemesAndTopics(subjects: IOption[]) {
  const token = localStorage.getItem('token')

  const [subjectsParams, setSubjectsParams] = useState('')

  useDebounce(
    () => {
      const params = new URLSearchParams(subjects.map((subject) => ['id', subject.value as string]))

      setSubjectsParams(params.toString())
    },
    500,
    [subjects]
  )

  const key =
    token && subjectsParams ? `/question/filter/themes-topics/subjects?${subjectsParams}` : null

  const swr = useSWR<IThemesAndTopics>(key, fetcher(token), configuration)

  return swr
}

const fetcher = (token: string) => (url: string) =>
  learningApi
    .get(url, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((res) => res.data)

const configuration: SWRConfiguration<IThemesAndTopics> = {
  fallbackData: {
    themes: [],
    topics: [],
  },
  onError() {
    toast.error('Não foi possível carregar os filtros de questões. Tente novamente mais tarde.')
  },
  errorRetryCount: 0,
}
